// Super-admin storage-configuration API (S58).
// Calls /api/v1/super/companies/:encId/storage[/test] — super JWT required.
// Response shapes are identical to the old tenant storage endpoints.

import { apiClient } from './client';
import type {
  StorageConfigInput,
  StorageTestResult,
  TenantStorageConfigPublic,
} from '../types/api';

export async function getSuperCompanyStorage(
  encId: string,
): Promise<TenantStorageConfigPublic | null> {
  const res = await apiClient.get<TenantStorageConfigPublic | null>(
    `/super/companies/${encodeURIComponent(encId)}/storage`,
  );
  return res.data;
}

export async function updateSuperCompanyStorage(
  encId: string,
  body: StorageConfigInput,
): Promise<TenantStorageConfigPublic> {
  const res = await apiClient.put<TenantStorageConfigPublic, StorageConfigInput>(
    `/super/companies/${encodeURIComponent(encId)}/storage`,
    body,
  );
  return res.data;
}

export async function testSuperCompanyStorage(
  encId: string,
  body: StorageConfigInput,
): Promise<StorageTestResult> {
  const res = await apiClient.post<StorageTestResult, StorageConfigInput>(
    `/super/companies/${encodeURIComponent(encId)}/storage/test`,
    body,
  );
  return res.data;
}

export async function deleteSuperCompanyStorage(encId: string): Promise<void> {
  await apiClient.delete(`/super/companies/${encodeURIComponent(encId)}/storage`);
}
